const prefixes = ["", "k", "M", "G", "T"];

const kilo = 1024;

export function formatSize(size: number, decimals = 2) {
  let index = 0;
  let tmp = size;
  while (tmp >= kilo) {
    tmp /= kilo;
    index += 1;
  }
  return `${tmp?.toFixed(decimals)} ${prefixes[index]}B`;
}
